import SpeechIconFallback from 'src/shared/assets/images/speech-bubble-no-bg.png'
import SpeechIconWebp from 'src/shared/assets/images/speech-bubble-no-bg.webp'
import SpeechIconSquareFallback from 'src/shared/assets/images/speech-bubble.png'
import SpeechIconSquareWebp from 'src/shared/assets/images/speech-bubble.webp'
import { cn } from 'src/shared/utils/cn'

import { WebpImage } from '../image/webp-image'

interface SpeechIconProps {
  className?: string
  iconClassName?: string
  variant?: 'rounded' | 'square'
}

/** Start journey speech bubble icon */
export default function SpeechIcon({ className, iconClassName, variant = 'rounded' }: SpeechIconProps) {
  if (variant === 'square') {
    return (
      <WebpImage
        src={SpeechIconSquareWebp}
        fallbackSrc={SpeechIconSquareFallback}
        alt=""
        containerClassName={cn('size-[30px] xs:size-[34px]', className)}
      />
    )
  }

  return (
    <div
      className={cn(
        'relative flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-full',
        'bg-[radial-gradient(50%_50%_at_50%_50%,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0)_100%),linear-gradient(180deg,#5AF675_0%,#16C433_100%)]',
        className,
      )}
    >
      <WebpImage
        src={SpeechIconWebp}
        fallbackSrc={SpeechIconFallback}
        alt=""
        containerClassName={cn('size-[30px] xs:size-[34px]', iconClassName)}
      />
    </div>
  )
}
